import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	if: {
		id: 'eoc.routing-rules.ui.rule-card-content.if.no-translate',
		defaultMessage: 'IF',
		description: 'Label of first rule condition',
	},
	elseIf: {
		id: 'eoc.routing-rules.ui.rule-card-content.else-if.no-translate',
		defaultMessage: 'ELSE IF',
		description: 'Label of other rule condition',
	},
	then: {
		id: 'eoc.routing-rules.ui.rule-card-content.then.no-translate',
		defaultMessage: 'THEN',
		description: 'The indicator of what gonna happen after conditions end',
	},
	routeAlertTo: {
		id: 'eoc.routing-rules.ui.rule-card-content.route-alert-to.no-translate',
		defaultMessage: 'route the alert to <strong>{entityName}</strong>',
		description: 'The label of "then" rule',
	},
	noOne: {
		id: 'eoc.routing-rules.ui.rule-card-content.no-one.no-translate',
		defaultMessage: 'No one',
		description: 'The label that appears if entity id/name does not exist.',
	},
	scheduleWarning: {
		id: 'eoc.routing-rules.ui.rule-card-content.schedule-warning.no-translate',
		defaultMessage: "Filtered alerts are not escalated because they're routed to a schedule",
		description: 'The label that appears if routing rule is schedule.',
	},
	deletedEntity: {
		id: 'eoc.routing-rules.ui.rule-card-content.deleted-entity.no-translate',
		defaultMessage: 'Deleted Entity',
		description: 'The label that appears if entity deleted',
	},
	forAny: {
		id: 'eoc.routing-rules.ui.rule-card-content.for-any-received-alert.no-translate',
		defaultMessage: 'for any received alert',
		description: 'Label of rule card condition',
	},
	routingTimeIsBetween: {
		id: 'eoc.routing-rules.common-messages.routing-time-is-between.no-translate',
		defaultMessage: 'routing time is between ',
		description: 'A text message that will be exist when routing rule is time restricted',
	},
});

export default messages;
